// extracted by mini-css-extract-plugin
export default {"footer":"ModalFooter_footer__IlXC+"};